import * as React from 'react';
import { Duration } from '../Duration';
import { useDurations } from '../../hooks/useDurations';
import * as styles from './DurationGrid.css';

export const DurationGrid = () => {
  const { onChange, durations, selectedDurationInDays } = useDurations();

  return (
    <div className={styles.root}>
      {durations.map(({ durationInDays, discountPercent }) => (
        <Duration
          key={durationInDays}
          duration={durationInDays}
          discount={discountPercent}
          checked={selectedDurationInDays === durationInDays}
          onClick={onChange}
        />
      ))}
    </div>
  );
};
